export default __webpack_public_path__ + "static/media/screen_livechat_20.d841080a.png";